/**
 * Hashes SHA-256 of usuario/contraseña (con pepper interno).
 * Para cambiar credenciales: node scripts/generate-admin-credentials.js
 * No commitear el script con valores en claro; generar localmente.
 */
export const CREDENTIAL_HASHES = {
  user: [
    79, 112, 141, 223, 12, 239, 108, 124, 223, 177, 30, 217, 87, 175, 179, 64, 4, 23, 210, 44, 229,
    221, 19, 107, 120, 88, 31, 188, 43, 150, 103, 206,
  ],
  pass: [
    167, 228, 51, 116, 199, 129, 40, 49, 88, 6, 72, 58, 120, 1, 114, 112, 11, 53, 44, 130, 210, 36,
    175, 33, 64, 161, 32, 116, 225, 65, 185, 36,
  ],
};
